export const statuses = [
  {
    value: "IN_PROGRESS",
    label: "In Progress",
    color: "bg-purple-600 text-white",
  },
  { value: "SUCCESS", label: "Success", color: "bg-green-600 text-white" },
  { value: "CANCELLED", label: "Cancelled", color: "bg-red-600 text-white" },
  { value: "FAILED", label: "Failed", color: "bg-orange-600 text-white" },
];
